module.exports = __webpack_public_path__ + "ath_game_web/img/7.8.1.399837cf.png";